export default "__VITE_ASSET__DwczxCjJ__"